// src/components/attributes/delete-attribute-dialog.tsx

/**
 * Delete Attribute Dialog
 * Confirmation dialog for deleting an attribute
 */

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog'

interface DeleteAttributeDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  attributeKey: string
  attributeName: string
  onConfirm: () => void
  isLoading?: boolean
}

export function DeleteAttributeDialog({
  open,
  onOpenChange,
  attributeKey,
  attributeName,
  onConfirm,
  isLoading = false,
}: DeleteAttributeDialogProps) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Delete Attribute</AlertDialogTitle>
          <AlertDialogDescription>
            Are you sure you want to delete the attribute{' '}
            <code className="rounded bg-muted px-1 py-0.5 font-mono text-sm">
              {attributeKey}
            </code>{' '}
            ({attributeName})?
            <br />
            <br />
            This action cannot be undone. Policies using this attribute may be
            affected.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isLoading}>Cancel</AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            disabled={isLoading}
            className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
          >
            {isLoading ? 'Deleting...' : 'Delete'}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
